module.exports = __webpack_public_path__ + "img/华泰证券.6af1fe6f.png";